import { formatDateToMonthYear } from "~/providers/utils";
import { MultiMedicationInThePastResponse } from "~/providers/utils/types/rawResponsesTypes";

interface MultiMedicationInThePastProps {
  questionCode: string;
  answers: MultiMedicationInThePastResponse[];
}

export const MultiMedicationInThePast = ({
  questionCode,
  answers,
}: MultiMedicationInThePastProps) =>
  answers.map((med) => (
    <div key={questionCode} className="flex flex-col gap-4">
      {med.medications_data.map((complementedMed) => (
        <div key={questionCode}>
          <p>{`${
            complementedMed.medication
          } (Started on ${formatDateToMonthYear(
            complementedMed.date_started,
          )})`}</p>
          <p>{`Dose: ${complementedMed.dose}`}</p>
          <p>{`Frequency: ${complementedMed.frequency}`}</p>
          <p>{`Experience: ${complementedMed.how_did_it_work}`}</p>
        </div>
      ))}
    </div>
  ));
